import * as zod from 'zod';

export const CNCOperateWorkholdingVariables = zod.object({});

export type CNCOperateWorkholdingVariables = zod.infer<
  typeof CNCOperateWorkholdingVariables
>;
